@if (isNotification()) {
  <div class="notification-container">
    @for (notification of notifications; track notification.id) {
      <div
          class="notification"
          #notificationModal
          [ngClass]="'notification--'+notification.type">
        <div class="notification__header">
          <i aria-hidden="true" class="icon" [ngClass]="getIcon(notification)" (click)="toggleNotification()"></i>
          <h5 class="notification__title" [attr.data-test]="'title-notification-window'">{{ notification.title | translate }}</h5>
          <button
              type="button"
              class="notification__close"
              aria-label="Close notification"
              (click)="closeAction(notification.id)"
              [attr.data-test]="'button-close-notification-window'">
            <i aria-hidden="true" class="icon-close notification-icon-close"></i>
          </button>
        </div>
        @if (notification?.messages) {
          <div class="notification__message">
            @for (message of notification.messages; track $index) {
              <span [ngClass]="message.css">
                {{ message.key | translate: message.params }}
              </span>
            }
          </div>
        }
        @if (notification?.actions) {
          <div class="notification__actions">
            @for (action of notification.actions; track $index) {
              <button
                  type="button"
                  class="button"
                  [ngClass]="action.css"
                  (click)="handleActions(action.type)">
                {{ action.label | translate }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
}
